import { Client, Functions } from 'appwrite';

const FUNCTION_ID = 'team-branding-manager';

interface TeamBrandingResult<T> {
  success: boolean;
  data?: T;
  error?: string;
}

const buildClient = () => new Client()
  .setEndpoint(import.meta.env.VITE_APPWRITE_ENDPOINT || '')
  .setProject(import.meta.env.VITE_APPWRITE_PROJECT_ID || '');

const callBrandingFunction = async <T>(action: string, parameters: Record<string, string>): Promise<T> => {
  const functions = new Functions(buildClient());
  const execution = await functions.createExecution(
    FUNCTION_ID,
    JSON.stringify({ action, parameters }),
    false,
    '/',
    'POST',
  );
  const result: TeamBrandingResult<T> = JSON.parse(execution.responseBody || '{}');
  if (result.success && result.data) {
    return result.data;
  }
  if (result.error) {
    throw new Error(result.error);
  }
  // Failed executions can come back with an empty body — give the user
  // something actionable instead of a bare "update failed".
  throw new Error('The branding service did not respond correctly. Try again, and contact support if it keeps failing.');
};

export const teamBrandingService = {
  updatePrimaryColour(teamId: string, colour: string): Promise<{ brand_primary_colour: string }> {
    return callBrandingFunction('update_primary_colour', {
      team_id: teamId,
      brand_primary_colour: colour,
    });
  },

  updateLogo(teamId: string, fileId: string): Promise<{ logo_url: string }> {
    return callBrandingFunction('update_logo', {
      team_id: teamId,
      logo_file_id: fileId,
    });
  },
};
